export default function gtmEvent(eventObject: object) {
  if (window.dataLayer) {
    window.dataLayer.push(eventObject);
  }
}